module.exports = "<div id=\"content-error-page\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-lg-8 col-lg-offset-2\">\n                <div class=\"logo\"></div>\n                <h1>Page not found</h1>\n                <p>Apologies, but the page you requested could not be found.</p>\n                <a ui-sref=\"r.in.top.home\" class=\"btn btn-link\">Okay, take me Home</a>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/404.html
// module id = 509
// module chunks = 0